import { useParentAttributeCreateMutation } from "@dashboard/graphql";
import useNavigator from "@dashboard/hooks/useNavigator";
import useNotifier from "@dashboard/hooks/useNotifier";
import React from "react";
import { useIntl } from "react-intl";

import ParentAttributePage, { ParentAttributePageFormData } from "../../components/ParentAttributePage";
import { ParentAttributeAddUrlQueryParams, parentAttributeUrl } from "../../urls";

interface ParentAttributeCreateProps {
  params: ParentAttributeAddUrlQueryParams;
}

const ParentAttributeCreate = ({ params }: ParentAttributeCreateProps) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const intl = useIntl();

  const [parentAttributeCreate, parentAttributeCreateOpts] = useParentAttributeCreateMutation({
    onCompleted: data => {
      if (data?.attributeCreate?.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            id: "parentAttrCreated",
            defaultMessage: "Successfully created parent attribute",
          }),
        });
        navigate(parentAttributeUrl(data?.attributeCreate?.attribute?.id ?? ""));
      }
    },
  });

  const handleSubmit = async (data: ParentAttributePageFormData) => {
    const result = await parentAttributeCreate({
      variables: {
        input: {
          name: data.name,
          slug: data.slug,
          type: "PRODUCT_TYPE",
          inputType: "DROPDOWN",
          isParentType: true,
        },
      },
    });

    return {
      id: result.data?.attributeCreate?.attribute?.id ?? undefined,
      errors: result.data?.attributeCreate?.errors ?? [],
    };
  };

  return (
    <ParentAttributePage
      parentAttribute={null}
      disabled={parentAttributeCreateOpts.loading}
      errors={parentAttributeCreateOpts?.data?.attributeCreate?.errors || []}
      onSubmit={handleSubmit}
      saveButtonBarState={parentAttributeCreateOpts.status}
    />
  );
};

ParentAttributeCreate.displayName = "ParentAttributeCreate";

export default ParentAttributeCreate;